import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  CreateTrainingPayload,
  PrepareUploadResult,
  RegistrationImpactResult,
  SetTrainingRecordingPayload,
  SubjectCatalogItem,
  TrainingRow,
  UpdateTrainingPayload,
} from "./formacion.types";

const schoolIdParams = (schoolId: number | null) =>
  schoolId === null ? {} : { schoolId };

export const createTraining = async (
  schoolId: number | null,
  payload: CreateTrainingPayload
): Promise<TrainingRow> => {
  try {
    const response: AxiosResponse<TrainingRow> = await api.post(
      "/trainings",
      payload,
      { params: schoolIdParams(schoolId) }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateTraining = async (
  schoolId: number | null,
  id: number,
  payload: UpdateTrainingPayload
): Promise<TrainingRow> => {
  try {
    const response: AxiosResponse<TrainingRow> = await api.patch(
      `/trainings/${id}`,
      payload,
      { params: schoolIdParams(schoolId) }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const setTrainingRecording = async (
  schoolId: number | null,
  id: number,
  payload: SetTrainingRecordingPayload
): Promise<TrainingRow> => {
  try {
    const response: AxiosResponse<TrainingRow> = await api.patch(
      `/trainings/${id}/recording`,
      payload,
      { params: schoolIdParams(schoolId) }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const prepareRecordingUpload = async (
  schoolId: number | null,
  id: number,
  contentType: string
): Promise<PrepareUploadResult> => {
  try {
    const response: AxiosResponse<PrepareUploadResult> = await api.post(
      `/trainings/${id}/recording-upload`,
      { contentType },
      { params: schoolIdParams(schoolId) }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const prepareCoverUpload = async (
  schoolId: number | null,
  id: number,
  contentType: string
): Promise<PrepareUploadResult> => {
  try {
    const response: AxiosResponse<PrepareUploadResult> = await api.post(
      `/trainings/${id}/cover-upload`,
      { contentType },
      { params: schoolIdParams(schoolId) }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

// SCRUM-1098 design §5: registrant impact for schools about to be removed
// from a training's audience. Read-only, no Zoom call.
export const getRegistrationImpact = async (
  id: number,
  schoolIds: number[]
): Promise<RegistrationImpactResult> => {
  try {
    const response: AxiosResponse<RegistrationImpactResult> = await api.get(
      `/trainings/${id}/registration-impact`,
      { params: { schoolIds } }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getSubjectCatalog = async (): Promise<SubjectCatalogItem[]> => {
  try {
    const response: AxiosResponse<{ data: SubjectCatalogItem[] }> =
      await api.get("/trainings/subject-catalog");
    return response.data.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
